import React, { useState} from 'react';
//import PropTypes from 'prop-types';
import {
  Label,
} from 'reactstrap';
import Services from '../services';
import _ from 'lodash';
import DropZone from 'react-dropzone';
import { ImageCard } from '../../../commons/controls';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import ToolbarBase from '../../../components/Wysiwyg/toolbar/ToolbarBase';
import Wysiwyg from '../../../components/Wysiwyg/Wysiwyg';


const ExtracontentForm = props => {
  
  const {
    angolNyelv,
    formTipus,
    formHelyszinek,
    formObjects,
    modositas,
    formObjectsAngol,
    formStatusz,
    onDropObjects,
    onDeleteClick,
    handleSelectInputChange,
    handleImgClick,
    handleLeirasChange,
    valtozok,
    addImage,
    removeImage
  } = props;

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && formHelyszinek.length === 0 && options.length === 1) {
          handleSelectInputChange(options[0], 'formHelyszinek')
        }
      }
    });
  }


  const loadExtracontentTipus = (input, callback) => {
    Services.listExtracontentTipus((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const handleStatuszInputChange = (v, item) => {
    if(v && v.target) {
        handleSelectInputChange(v.target.value, item);
      }
    }

    const renderEditor = (fieldName) => {
      let field = props[fieldName];
      return <Wysiwyg value={field} onChange={(value) => { handleLeirasChange(fieldName, value) }} toolbar={() => <ToolbarBase />} onImageUpload={addImage} onImageRemove={removeImage} />
    }

  return (
    <>
      <div className="row">
        <div className="col-md-6" style={{paddingRight: '2px'}}>
          <SelectField
            variant='async'
            label='Típus:'
            name="formTipus"
            id="formTipus"
            placeholder="Válassz típust!"
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, 'formTipus')}
            loadOptions={_.debounce(loadExtracontentTipus, 1000)}
            getOptionLabel={option => option.caption}
            getOptionValue={option => option.name}
            value={formTipus}
            isClearable
            defaultOptions
            required
          />
        </div>
        <div className="col-md-6" style={{paddingRight: '2px'}}>
          <SelectField
            variant='async'
            label='Helyszínek:'
            name="formHelyszinek"
            id="formHelyszinek"
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, 'formHelyszinek')}
            loadOptions={_.debounce(loadHelyszinOptions, 1000)}
            getOptionLabel={option => option.nev}
            getOptionValue={option => option.id}
            value={formHelyszinek}
            cache={false}
            isLoading={false}
            isMulti
            isClearable
            defaultOptions
            required
          />
        </div>
        <div className="col-md-6">
          <Label> Képek: </Label>
          <DropZone multiple onDrop={(files) => onDropObjects(files, 'hu')} className="custom-dropzone" style={{ height: '50px' }} accept="image/*">
            {({getRootProps, getInputProps}) => (
                <div {...getRootProps({ className: 'custom-dropzone'})}>
                  <input {...getInputProps()} />
                  <div className="dropzone-text">
                    {'Kép feltöltése!'}
                  </div>
                </div>
            )}
          </DropZone>
        </div>
        {angolNyelv &&
          <div className="col-md-6">
            <Label> Képek (angol): </Label>
            <DropZone multiple onDrop={(files) => onDropObjects(files, 'en')} className="custom-dropzone" style={{ height: '50px' }} accept="image/*">
              {({getRootProps, getInputProps}) => (
                  <div {...getRootProps({ className: 'custom-dropzone'})}>
                    <input {...getInputProps()} />
                    <div className="dropzone-text">
                      {'Kép feltöltése!'}
                    </div>
                  </div>
              )}
            </DropZone>
          </div>
        }
        {!angolNyelv && <div className='col-md-6' />}
        <div className="col-md-6">
          {formObjects && formObjects.map((item, idx) => {
            return (
              <div className="col-md-12" key={idx.toString()}>
                <ImageCard
                  //style={{maxWidth: '200px'}}
                  poster
                  key={idx.toString()}
                  mime={item.mime}
                  title={item.docname}
                  content={item.content}
                  main={item.main}
                  src={item.src}
                  style={{ height: "200px" }}
                  onViewClick={v => handleImgClick(item, idx)}
                  onDeleteClick={v => onDeleteClick(item, 'hu')}
                />
              </div>
            );
          })}
        </div>
        <div className="col-md-6">
          {angolNyelv && formObjectsAngol && formObjectsAngol.map((item, idx) => {
            return (
              <div className="col-md-12" key={idx.toString()}>
                <ImageCard
                  //style={{maxWidth: '200px'}}
                  poster
                  key={idx.toString()}
                  mime={item.mime}
                  title={item.docname}
                  content={item.content}
                  main={item.main}
                  src={item.src}
                  style={{ height: "200px" }}
                  onViewClick={v => handleImgClick(item, idx)}
                  onDeleteClick={v => onDeleteClick(item, 'en')}
                />
              </div>
            );
          })}
        </div>
      </div>
            <div className='row'>
        <React.Fragment>
          <div className='col-md-12'>
            <Label for="leiras">Leírás:</Label>
            {renderEditor('leiras')}
          </div>
          <div className='col-md-12'>
            {angolNyelv &&
              <div>
                <Label for="leirasangol">Leírás (angol): *</Label>
                {renderEditor('leirasAngol')}
              </div>
            }
          </div>
        </React.Fragment>
      </div>
      <RFField
        type="select"
        name="formStatusz"
        label="Státusz: *"
        required
        value={formStatusz}
        onChange={v => {handleStatuszInputChange(v, 'formStatusz')}}
        defaultSelect={
          <>
            <option value="">Válassz státuszt...</option>
            <option value="INAKTIV">Inaktív</option>
            <option value="AKTIV">Aktív</option>
          </>
        }
      />
    </>
  )
  
}

export default ExtracontentForm;